
































import { Component, Vue, Prop } from 'vue-property-decorator';
import { CollectionItem } from '@/resource/collection-item/collection-item.model';

@Component({})
export default class ItemInfo extends Vue {
  @Prop({ required: true })
  collectionItem!: CollectionItem;

  showOption = false;

  get subject() {
    return `${this.question.chapter.subject.name}`;
  }

  get form() {
    return `${this.question.chapter.form - 6}`;
  }

  get chapter() {
    return `${this.question.chapter.prefix}`;
  }

  get questionInfos() {
    return [
      {
        title: 'Subject',
        value: `${this.question.chapter.subject.name}`,
      },
      {
        title: 'Form',
        value: `${this.question.chapter.form - 6}`,
      },
      {
        title: 'Chapter',
        value: `${this.question.chapter.prefix}`,
      },
    ];
  }

  get question() {
    const objective = this.collectionItem.questionObjective;
    const subjective = this.collectionItem.questionSubjective;

    return objective || subjective;
  }

  toggleOption() {
    this.showOption = !this.showOption;
  }

  deleteItemClicked() {
    this.$emit('deleteItemClicked');
  }
}
